export default function NoteBand() {
  return (
    <section className="w-full bg-background-50 pb-4 md:pb-8">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="rounded-lg border border-background-200/80 bg-accent-50/60 px-6 md:px-12 py-10 md:py-14 text-center">
          <span className="w-9 h-9 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-5">
            <i className="ri-double-quotes-l text-lg" />
          </span>
          <p className="font-heading text-lg md:text-2xl text-foreground-900 leading-relaxed">
            没有哪一家是唯一正确的答案，只有更适合你当下习惯的那一家。
            <br className="hidden md:block" />
            先把差别看明白，再决定要不要换。
          </p>
          <p className="mt-6 text-xs md:text-sm text-foreground-500">—— 一份来自社区的共同笔记</p>
        </div>
      </div>
    </section>
  );
}